import React from 'react';
import { Col, Card } from 'react-bootstrap';
import PropTypes from 'prop-types';

import './MemberCard.css';

const PLACEHOLDER_IMG = `${process.env.PUBLIC_URL || ''}/images/avatar-placeholder.svg`;

export default function MemberCard({
    name,
    avatarUrl,
    profileUrl,
    title,
    university,
    bio,
    size = 'researcher',
}) {
    const isLeader = size === 'leader';

    const imgSrc = avatarUrl
        ? `${avatarUrl}${avatarUrl.includes('?') ? '&' : '?'}size=500`
        : PLACEHOLDER_IMG;

    const altText = avatarUrl ? name : `No profile picture for ${name}`;

    return (
        <Col
            lg={isLeader ? 4 : 3}
            md={isLeader ? 6 : 4}
            xs={6}
            className="member-card-col mb-4"
        >
            <Card className="h-100 border-0 shadow-sm text-center member-card">
                <Card.Body className="p-4">
                    <img
                        src={imgSrc}
                        alt={altText}
                        className="rounded-circle mb-3 member-card-photo"
                    />
                    <Card.Title
                        className={
                            isLeader ? 'h5 text-primary' : 'h6 text-primary'
                        }
                    >
                        {profileUrl ? (
                            <a
                                href={profileUrl}
                                className="link-dark link-offset-2 text-wrap fw-normal link-underline-opacity-25 link-underline-opacity-100-hover"
                            >
                                {name}
                                <span className="visually-hidden">
                                    Click to see profile of {name}.
                                </span>
                            </a>
                        ) : (
                            <span className="text-dark text-wrap fw-normal">
                                {name}
                            </span>
                        )}
                    </Card.Title>
                    <Card.Text as="div" className="text-muted small">
                        <span className="d-block">{title}</span>
                        <span className="d-block">{university}</span>
                        {/* <span className="d-block">{timeline}</span> */}
                    </Card.Text>
                    {isLeader && bio && (
                        <p className="small mt-2 text-muted">{bio}</p>
                    )}
                </Card.Body>
            </Card>
        </Col>
    );
}

MemberCard.propTypes = {
    name: PropTypes.string.isRequired,
    avatarUrl: PropTypes.string,
    profileUrl: PropTypes.string,
    title: PropTypes.string,
    university: PropTypes.string,
    bio: PropTypes.string,
    size: PropTypes.oneOf(['leader', 'researcher']),
};
